export const CHECKOUT_URL = "https://pay.kiwify.com.br/LOrs7VR";
export const PRICE_ORIGINAL = "R$ 47,90";
export const PRICE_DISCOUNTED = "R$ 29,90";
export const BOOK_COVER = "/assets/estoico-capa.jpeg";
